import { useEffect } from "react";
import { Redirect } from "react-router-dom";

import { connect } from "react-redux";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "../state/index";
import { bindActionCreators } from "redux";

function Logout(props: any) {
  const { history } = props ?? {};

  // Redux
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreators.authActions, dispatch);

  useEffect(() => {
    dispatch(logout());
  }, []);
  return <Redirect to="/" />;
}

export default Logout;
